import { createAction } from '@reduxjs/toolkit';
import { LocalStorage } from '../../shared/utils';

export const setUpdateAiTierBannerState = createAction('billing/setUpdateAiTierBannerState');

export const reducer = (builder) => {
  builder.addCase(
    setUpdateAiTierBannerState.type,
    (state, { payload }) => {
      LocalStorage.set('isUpdateAiTierBannerHidden', payload);

      return { ...state, isUpdateAiTierBannerHidden: payload };
    },
  );
};
